// 轮播图配置文件
export const bannerConfig = {
  // 通用产品轮播图（适用于www, app等）
  common: [
    {
      type: 'product',
      title: '智能办公 AI Office',
      intro: '让工作更轻松高效',
      explain: '智慧办公————以人工智能技术为基石，<br />通过软硬件结合产品落地到办公场景，打造新一代<br />"简单、高效、友好"办公场景，提升人类工作效率和幸福感',
      image: 'ai-img-office.png',
      showCondition: (currentHost) => {
        const excludeHosts = ['hgai','yundesk', 'wo', 'tele', 'jiyuai', 'm70', 'p70', 'lefan', 'sir', 'pansheng', 'newland', 'i70', 'm7', 'miaowang', 'mifi', 'yff', 'zuoh', 'xunxiang', 'hbs', 'www.hbs', 'zxhy', 'beite', 'keliumao', 'jingying', 'dike'];
        return !excludeHosts.includes(currentHost);
      }
    },
    {
      type: 'product',
      title: '智能语音鼠标-<span class="color-o">V8</span>',
      intro: '一分钟可打<span class="color-o font-w600">400字</span>',
      explain: '语音打字 | 100+全球语言 | 24种方言',
      image: 'ai-img-mouse.png',
      showCondition: (currentHost, brandSubdomain) => ['www', 'app'].some(host => host === brandSubdomain)
    },
    {
      type: 'product',
      title: '智能翻页演讲笔<span class="color-o"></span>',
      intro: '<span class="color-o font-w600">实时</span>录音、翻译字幕',
      explain: '语音打字 | 100+全球语言 | 24种方言',
      image: 'ai-img-fyb.png',
      showCondition: (currentHost, brandSubdomain) => ['www', 'app', 'baseus'].some(host => host === brandSubdomain)
    },
    {
      type: 'product',
      title: '智能语音键盘<span class="color-o"></span>',
      intro: '能<span class="color-o font-w600">"说话打字"</span>操控的键盘',
      explain: '语音打字 | 智能搜索 | 翻译打字 | 智能M键',
      image: 'ai-img-keyboard.png',
      showCondition: (currentHost, brandSubdomain) => ['www', 'app'].some(host => host === brandSubdomain)
    },
    {
      type: 'product',
      title: '录音翻译会议耳机-<span class="color-o">A03</span>',
      intro: '<span class="color-o font-w600">电话录音 会议APP录音</span>',
      explain: '通话翻译 | 通话录音 | 来电报姓名',
      image: 'ai-img-ej.png',
      showCondition: (currentHost, brandSubdomain) => ['www', 'app'].some(host => host === brandSubdomain)
    },
    {
      type: 'product',
      title: '智能录音笔-<span class="color-o">R3/R5</span>',
      intro: '边<span class="color-o font-w600">写</span>边<span class="color-o font-w600">录</span>出口成章',
      explain: '高清录音 | 语音速记 | 一键分享',
      image: 'ai-img-record.png',
      showCondition: (currentHost, brandSubdomain) => ['www', 'app'].some(host => host === brandSubdomain)
    },
    {
      type: 'product',
      title: '智能全向麦<span class="color-o"></span>',
      intro: '会议室<span class="color-o font-w600">"伴侣"</span>',
      explain: '会议纪要 | 纪要分享 | 通话录音 | 通话翻译',
      image: 'ai-img-qxm.png',
      showCondition: (currentHost, brandSubdomain) => ['www', 'app'].some(host => host === brandSubdomain)
    }
  ],

  // 品牌特定轮播图
  brands: {
    hgai: [
      { type: 'brand', backgroundImage: 'hgai-banner.png' }
    ],
    yundesk: [
      { type: 'brand', backgroundImage: 'yundesk-banner.png' }
    ],
    wo: [
      { type: 'brand', backgroundImage: 'liantong-banner.png' }
    ],
    tele: [
      { type: 'brand', backgroundImage: 'tele-banner.png' }
    ],
    jiyuai: [
      { type: 'brand', backgroundImage: 'vm1-mini.jpg' },
      { type: 'brand', backgroundImage: 'vm1-pro.jpg' },
      { type: 'brand', backgroundImage: 'vm1-ultra.jpg' }
    ],
    m70: [
      { type: 'brand', backgroundImage: 'm70-banner.png' }
    ],
    p70: [
      { type: 'brand', backgroundImage: 'p70-banner.png' }
    ],
    lefan: [
      { type: 'brand', backgroundImage: 'lefan-banner.jpg' }
    ],
    sir: [
      { type: 'brand', backgroundImage: 'lefan-banner.jpg' }
    ],
    i70: [
      { type: 'brand', backgroundImage: 'i70-banner.png' }
    ],
    pansheng: [
      { type: 'brand', backgroundImage: 'pansheng-banner.png' }
    ],
    newland: [
      { type: 'brand', backgroundImage: 'newland-banner.png' }
    ],
    m7: [
      { type: 'brand', backgroundImage: 'M7-banner.png' }
    ],
    miaowang: [
      { type: 'brand', backgroundImage: 'miaowang-banner.png' }
    ],
    mifi: [
      { type: 'brand', backgroundImage: 'mifi-banner.png' }
    ],
    yff: [
      { type: 'brand', backgroundImage: 'yff-banner.jpg' }
    ],
    zuoh: [
      { type: 'brand', backgroundImage: 'zuoh-banner.png' }
    ],
    hbs: [
      { type: 'brand', backgroundImage: 'hbs-banner.png' }
    ],
    zxhy: [
      { type: 'brand', backgroundImage: 'zxhy-banner.png' }
    ],
    beite: [
      { type: 'brand', backgroundImage: 'beite-banner.png' }
    ],
    keliumao: [
      { type: 'brand', backgroundImage: 'keliumao-banner.png' }
    ],
    jingying: [
      { type: 'brand', backgroundImage: 'jingying-banner.png' }
    ],
    xunxiang: [
      { type: 'swiper', images: 'xunxiang' } // 特殊处理，使用图片组
    ],
    dike: [
      { type: 'brand', backgroundImage: 'dike-banner.png' }
    ],
  }
};

// 获取图片路径的工具函数
export const getImagePath = (imageName) => {
  return require(`../assets/images/${imageName}`);
};

// 获取背景图片路径的工具函数
export const getBackgroundImagePath = (imageName) => {
  return require(`../assets/images/${imageName}`);
};
